/* eslint-disable react-hooks/rules-of-hooks */
import {
  DeleteOutlined,
  ExportOutlined,
  FormOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Table,
  notification,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import excel from "xlsx";
import "./style.css";

import { Env } from "./../../../styles";

const { TextArea } = Input;
const { Option } = Select;

export default function TasksAccounts(props) {
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(true);
  const [loadReport, setLoadReport] = useState(false);
  const [tstypes, setTstypes] = useState([]);
  const [types, setTypes] = useState([]);
  const [namesFilter, setNamesFilter] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().format("YYYY"));

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDModalVisible, setIsDModalVisible] = useState(false);

  const [saving, setSaving] = useState(false);
  const [dsaving, setDSaving] = useState(false);

  const [tasksTypes, setTasksTypes] = useState([]);
  const [empNames, setEmpNames] = useState([]);
  const [selectedName, setSelectedName] = useState(null);
  const [start, setStart] = useState(
    new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .slice(0, 10)
  );
  const [end, setEnd] = useState(new Date().toISOString().slice(0, 10));
  const [loadUsers, setLoadUsers] = useState(false);
  const [update, setUpdate] = useState(false);
  const [categories, setCategories] = useState([]);
  const [pdata, setPData] = useState([]);
  const [categoriesFilter, setCategoriesFilter] = useState([]);
  const [annTasks, setAnnTasks] = useState([]);
  const [pannTasks, setPAnnTasks] = useState([]);

  const normalizeText = (value) =>
    (value ?? "").toString().trim().toLowerCase();
  const matchesFilterValue = (recordValue, filterValue) =>
    normalizeText(recordValue) === normalizeText(filterValue);

  const showAccount = (user_id) => {
    setIsModalVisible(true);
    axios
      .get(
        Env.HOST_SERVER_NAME +
          "get-tasks-statment/" +
          user_id +
          "/" +
          currentYear
      )
      .then((response) => {
        form.setFieldsValue({ tasks: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getColumnsVac = () => {
    if (tasksTypes.length > 0) {
      const ncolumns = [
        {
          title: "اسم الموظف",
          dataIndex: "empName",
          key: "empName",
          sorter: (a, b) => a.empName.length - b.empName.length,
          sortOrder: sortedInfo.columnKey === "empName" && sortedInfo.order,
          ellipsis: false,
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <NamesFilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            />
          ),
          onFilter: (value, record) => matchesFilterValue(record.empName, value),
          filteredValue: filteredInfo.empName || null,
        },
        {
          title: "الإدارة",
          dataIndex: "category",
          key: "category",
          sorter: (a, b) => a.category.length - b.category.length,
          sortOrder: sortedInfo.columnKey === "category" && sortedInfo.order,
          ellipsis: false,
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <CategoriesFilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            />
          ),
          onFilter: (value, record) => {
            const result = matchesFilterValue(record.category, value);
            return result;
          },
          filteredValue: filteredInfo.category || null,
        },
        {
          title: "الوظيفة",
          dataIndex: "job",
          key: "job",
          ellipsis: true,
        },
      ];
      var col = "[";
      tasksTypes.map((task) => {
        col +=
          '{"title":"' +
          task.label +
          '","dataIndex":"' +
          task.label +
          '","key":"' +
          task.label +
          '"},';
      });
      var nc = JSON.parse(col.substring(0, col.length - 1) + "]");
      nc.map((col) => {
        ncolumns.push(col);
      });
      ncolumns.push({
        title: "الأحداث",
        dataIndex: "user_id",
        key: "user_id",
        ellipsis: true,
        render: (user_id, record, index) => (
          <Button
            onClick={function () {
              showAccount(user_id);
            }}
            type="primary"
            shape="round"
            icon={<FormOutlined />}
          ></Button>
        ),
      });
      return ncolumns;
    } else return [];
  };

  useEffect(() => {
    var emp;
    var tasks;
    var records;
    axios
      .get(Env.HOST_SERVER_NAME + "get-emp-names")
      .then((response) => {
        setEmpNames(response.data);
        setTstypes(response.data);
        emp = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    axios
      .get(Env.HOST_SERVER_NAME + "get-tasks-types-re")
      .then((response) => {
        setTasksTypes(response.data);
        tasks = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    setLoad(true);
    if (end != "")
      axios
        .get(Env.HOST_SERVER_NAME + "get-rest-tasks/" + currentYear)
        .then((response) => {
          if (
            response.data.tasks?.length > 0 &&
            emp?.length > 0 &&
            tasks?.length > 0
          ) {
            var vacData = "[";
            emp.map((user, index) => {
              vacData +=
                "{" +
                '"empName":"' +
                user.label +
                '","user_id":"' +
                user.value +
                '","category":"' +
                response.data.tasks?.filter(
                  (record) => record.user_id == user.value
                )[0]?.category +
                '","job":"' +
                response.data.tasks?.filter(
                  (record) => record.user_id == user.value
                )[0]?.job +
                '",';

              var vacDetails = "";
              tasks.map((task) => {
                var dur = response.data.tasks?.filter(
                  (record) =>
                    record.uid == user.value && record.vid == task.value
                );

                if (dur.length > 0)
                  dur =
                    dur[0].rest < 0
                      ? "-"
                      : "" +
                        Math.abs(parseInt(dur[0].rest / 60)) +
                        ":" +
                        Math.abs(dur[0].rest % 60);
                else dur = 0;

                vacDetails += '"' + task.label + '":"' + dur + '",';
              });

              vacData += vacDetails.substring(0, vacDetails.length - 1);
              vacData += "},";
            });

            // console.log(vacData.substring(0, vacData.length - 1)+']');
            var json = JSON.parse(
              vacData.substring(0, vacData.length - 1) + "]"
            );

            records = json;

            setData(json);
            setPData(json);
          }

          let names = [];
          let categories = [];
          records.forEach((element) => {
            if (!names.some((item) => element.name == item.text))
              names.push({
                text: element["empName"],
                value: element["empName"],
              });
            if (!categories.some((item) => element.category == item.text))
              categories.push({
                text: element["category"],
                value: element["category"],
              });
          });
          names = names.sort((a, b) => a.text.localeCompare(b.text));
          // Add "Select All" option to names filter
          const namesWithSelectAll = [
            { text: "تحديد الكل", value: "SELECT_ALL_NAMES" },
            ...names,
          ];

          categories = categories.sort((a, b) => a.text.localeCompare(b.text));
          // Add "Select All" option to categories filter
          const categoriesWithSelectAll = [
            { text: "تحديد الكل", value: "SELECT_ALL_CATEGORIES" },
            ...categories,
          ];

          setNamesFilter(namesWithSelectAll);
          setCategoriesFilter(categoriesWithSelectAll);

          setCategories(response.data.categories);
          //setData(response.data.tasks);

          /*     let names=[];
      console.log(response.data);
      response.data["tasks"].forEach(element => {  
        if(!names.some(item => element.fullname == item.text)){      
          names.push({text:element['fullname'],value:element['fullname']});
        }       
    }); 
    names=names.sort((a, b) =>  a.text.localeCompare(b.text));
    // Add "Select All" option to names filter
    const namesWithSelectAll = [
      { text: "تحديد الكل", value: "SELECT_ALL_NAMES" },
      ...names
    ];
    setNamesFilter(namesWithSelectAll);
      setData(response.data['tasks']);
      setTypes(response.data['types']);

*/
          setTypes(response.data["types"]);
          setLoad(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    axios
      .get(Env.HOST_SERVER_NAME + "get-annualy-tasks-report/2/" + currentYear)
      .then((response) => {
        setAnnTasks(response.data);
        setPAnnTasks(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [start, end, update, currentYear]);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);

    if (!filters || Object.keys(filters).length === 0) {
      setPData(data);
      setPAnnTasks(annTasks);
      return;
    }

    const hasActiveFilters = Object.values(filters).some(
      (value) => Array.isArray(value) && value.length > 0
    );

    if (!hasActiveFilters) {
      setPData(data);
      setPAnnTasks(annTasks);
      return;
    }

    const filterPredicate = (item) =>
      Object.entries(filters).every(([key, selectedValues]) => {
        if (!Array.isArray(selectedValues) || !selectedValues.length) {
          return true;
        }

        return selectedValues.some((filterValue) =>
          matchesFilterValue(item[key], filterValue)
        );
      });

    setPData(data.filter(filterPredicate));
    setPAnnTasks(annTasks.filter(filterPredicate));
  };
  const printReport = () => {
    var report = document.getElementById("att-report");
    // var report = document.getElementById("ann-report");
    //var report=document.body;
    var mywindow = window.open("");
    mywindow.document.write(
      "<html><head><title></title> <style>@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@500&display=swap'); body{font-family:Tajawal;font-size:12px;margin:0}  </style>"
    );
    mywindow.document.write('</head><body dir="rtl" style="font-size:12px;" >');
    mywindow.document.write(report.innerHTML);
    mywindow.document.write("</body></html>");

    // mywindow.document.close();
    mywindow.onload = function () {
      // wait until all resources loaded
      mywindow.focus(); // necessary for IE >= 10
      mywindow.print(); // change window to mywindow
      mywindow.close(); // change window to mywindow
    };
  };

  const exportToExcel = (type, fn, dl) => {
    var elt = document.getElementById("att-report");
    if (elt) {
      var wb = excel.utils.table_to_book(elt, {
        sheet: "sheet1",
        cellStyles: true,
      });
      return dl
        ? excel.write(wb, {
            bookType: type,
            bookSST: true,
            type: "base64",
            cellStyles: true,
          })
        : excel.writeFile(wb, fn || "كشف أرصدة الإجازات." + (type || "xlsx"), {
            bookSST: true,
            type: "base64",
            cellStyles: true,
          });
    }
  };
  const openNotification = (placement) => {
    notification.success({
      message: <span> تم إضافة الرصيد بنجاح </span>,
      placement,
      duration: 10,
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    gform.resetFields();
  };

  const handleDCancel = () => {
    setIsDModalVisible(false);
    dform.resetFields();
  };
  const showUsersDebt = () => {
    setLoadUsers(true);
    axios
      .get(Env.HOST_SERVER_NAME + "get-users-long-debts/")
      .then((response) => {
        setLoadUsers(false);

        var tasks = response.data;
        const finalData = tasks.map((item) => ({
          ...item,
          amount: gform.getFieldValue("amount"),
          task_id: gform.getFieldValue("task_id"),
          type: gform.getFieldValue("type"),
          period_type: gform.getFieldValue("period_type") || "monthly",
        }));

        form.setFieldsValue({ tasks: finalData });
      })
      .catch(function (error) {
        console.log(error);
        setLoadUsers(false);
      });
  };
  const [form] = Form.useForm();
  const [dform] = Form.useForm();
  const [gform] = Form.useForm();

  const onFinish = () => {
    setSaving(true);
    const formData = form.getFieldsValue();

    // إضافة الحقول الجديدة من النموذج العلوي
    const globalData = gform.getFieldsValue();

    // تحديث البيانات مع الحقول الجديدة
    if (formData.tasks) {
      formData.tasks = formData.tasks.map((task) => ({
        ...task,
        period_type: task.period_type || globalData.period_type || "monthly",
      }));
    }

    axios
      .post(Env.HOST_SERVER_NAME + "add-balance-tasks", formData)
      .then((response) => {
        setSaving(false);
        setIsModalVisible(false);
        form.resetFields();
        gform.resetFields();
        setUpdate(update + 1);
        openNotification("bottomLeft", selectedName);
      })
      .catch(function (error) {
        alert("يوجد مشكلة في الاتصال بالسرفر!");
        setSaving(false);
      });
  };

  const onDFinish = () => {
    setDSaving(true);
    axios
      .post(
        Env.HOST_SERVER_NAME + "discount-task-account",
        dform.getFieldsValue()
      )
      .then((response) => {
        setDSaving(false);
        setIsDModalVisible(false);
        dform.resetFields();
        setUpdate(update + 1);
        notification.success({
          message: "تم خصم الرصيد بنجاح ",
          placement: "bottomLeft",
          duration: 10,
        });
      })
      .catch(function (error) {
        alert("يوجد مشكلة في الاتصال بالسرفر!");
        setDSaving(false);
      });
  };
  function printAnnualyReport() {
    setLoadReport(true);
    var report = document.getElementById("ann-report");
    var mywindow = window.open("");
    setLoadReport(false);
    mywindow.document.write(
      "<html><head><title></title> <style>@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@500&display=swap'); body{font-family:Tajawal;font-size:12px;margin:0}  </style>"
    );
    mywindow.document.write('</head><body dir="rtl" style="font-size:12px;" >');
    mywindow.document.write(report.innerHTML);
    mywindow.document.write("</body></html>");
    mywindow.document.close();
    mywindow.onload = function () {
      // wait until all resources loaded
      mywindow.focus(); // necessary for IE >= 10
      mywindow.print(); // change window to mywindow
      mywindow.close(); // change window to mywindow
    };
  }
  const onChange = (all, date) => {
    setCurrentYear(date);
  };
  var index = 1;
  var aindex = 1;
  var tttasksTypes = Array(tasksTypes.length).fill(0);
  var months = [
    "يناير",
    "فبراير",
    "مارس",
    "إبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];
  var tprevBalance = 0;
  var tcurrBalance = 0;
  var ttransBalance = 0;
  var topBalance = 0;
  var ttotalgBalance = 0;
  var tmonthsBalance = {
    m1: 0,
    m2: 0,
    m3: 0,
    m4: 0,
    m5: 0,
    m6: 0,
    m7: 0,
    m8: 0,
    m9: 0,
    m10: 0,
    m11: 0,
    m12: 0,
  };

  // Custom filter dropdown component for names
  const NamesFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const [searchText, setSearchText] = useState("");
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
      if (selectAll) {
        // Deselect all
        setSelectedKeys([]);
        setSelectAll(false);
      } else {
        // Select all
        const allValues = namesFilter
          .filter((name) => name.value !== "SELECT_ALL_NAMES")
          .map((name) => name.value);
        setSelectedKeys(allValues);
        setSelectAll(true);
      }
    };

    const handleConfirm = () => {
      confirm();
    };

    const handleClear = () => {
      clearFilters();
      setSelectedKeys([]);
      setSelectAll(false);
    };

    const filteredNames = namesFilter.filter(
      (name) =>
        name.value !== "SELECT_ALL_NAMES" &&
        name.text.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="البحث..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ fontWeight: "bold" }}
          >
            تحديد الكل
          </Checkbox>
        </div>
        <div style={{ maxHeight: 200, overflow: "auto" }}>
          {filteredNames.map((name) => (
            <div key={name.value} style={{ marginBottom: 4 }}>
              <Checkbox
                checked={selectedKeys.includes(name.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, name.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== name.value)
                    );
                  }
                  setSelectAll(false);
                }}
              >
                {name.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, textAlign: "right" }}>
          <Button size="small" onClick={handleClear} style={{ marginRight: 8 }}>
            مسح
          </Button>
          <Button type="primary" size="small" onClick={handleConfirm}>
            تأكيد
          </Button>
        </div>
      </div>
    );
  };

  // Custom filter dropdown component for categories
  const CategoriesFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const [searchText, setSearchText] = useState("");
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
      if (selectAll) {
        // Deselect all
        setSelectedKeys([]);
        setSelectAll(false);
      } else {
        // Select all
        const allValues = categoriesFilter
          .filter((category) => category.value !== "SELECT_ALL_CATEGORIES")
          .map((category) => category.value);
        setSelectedKeys(allValues);
        setSelectAll(true);
      }
    };

    const handleConfirm = () => {
      confirm();
    };

    const handleClear = () => {
      clearFilters();
      setSelectedKeys([]);
      setSelectAll(false);
    };

    const filteredCategories = categoriesFilter.filter(
      (category) =>
        category.value !== "SELECT_ALL_CATEGORIES" &&
        category.text.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="البحث..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ fontWeight: "bold" }}
          >
            تحديد الكل
          </Checkbox>
        </div>
        <div style={{ maxHeight: 200, overflow: "auto" }}>
          {filteredCategories.map((category) => (
            <div key={category.value} style={{ marginBottom: 4 }}>
              <Checkbox
                checked={selectedKeys.includes(category.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, category.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== category.value)
                    );
                  }
                  setSelectAll(false);
                }}
              >
                {category.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, textAlign: "right" }}>
          <Button size="small" onClick={handleClear} style={{ marginRight: 8 }}>
            مسح
          </Button>
          <Button type="primary" size="small" onClick={handleConfirm}>
            تأكيد
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Card>
      <Modal
        centered
        confirmLoading={saving}
        title="إضافة رصيد إجازة موظف"
        visible={isModalVisible}
        width={900}
        onCancel={handleCancel}
        onOk={onFinish}
      >
        <div style={{ padding: "20px" }}>
          {/* النموذج العلوي - الإعدادات الأساسية */}
          <div style={{ marginBottom: "25px" }}>
            <h3
              style={{
                marginBottom: "15px",
                color: "#1890ff",
                borderBottom: "2px solid #1890ff",
                paddingBottom: "5px",
              }}
            >
              الإعدادات الأساسية
            </h3>
            <Form form={gform} layout="vertical" style={{ gap: "15px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "20px",
                }}
              >
                <Form.Item
                  name="task_id"
                  label="نوع الإجازة"
                  rules={[{ required: true, message: "مطلوب" }]}
                  style={{ marginBottom: "10px" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    placeholder="اختر نوع الإجازة"
                    optionFilterProp="children"
                    notFoundContent={<Spin size="small" />}
                    filterOption={(input, option) =>
                      option.props.children?.indexOf(input) >= 0 ||
                      option.props.value?.indexOf(input) >= 0 ||
                      option.props.label?.indexOf(input) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.props?.children?.localeCompare(
                        optionB.props.children
                      )
                    }
                    onChange={(value) => {
                      const selectedTask = tasksTypes.find(
                        (t) => t.value === value
                      );
                      if (
                        selectedTask &&
                        (selectedTask.label?.includes("سنوية") ||
                          selectedTask.label?.includes("سنة") ||
                          selectedTask.label?.includes("yearly") ||
                          selectedTask.label?.includes("annual"))
                      ) {
                        gform.setFieldValue("period_type", "yearly");
                      }
                    }}
                  >
                    {tasksTypes.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="type"
                  label="نوع الرصيد"
                  style={{ marginBottom: "10px" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    placeholder="اختر نوع الرصيد"
                    optionFilterProp="children"
                    options={
                      types && types.length > 0
                        ? types.filter(function (e) {
                            return e.parent == 34;
                          })
                        : []
                    }
                    notFoundContent={<Spin size="small" />}
                    filterOption={(input, option) =>
                      option.props.children?.indexOf(input) >= 0 ||
                      option.props.value?.indexOf(input) >= 0 ||
                      option.props.label?.indexOf(input) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.props?.children?.localeCompare(
                        optionB.props.children
                      )
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="period_type"
                  label="نوع الفترة"
                  rules={[{ required: true, message: "مطلوب" }]}
                  style={{ marginBottom: "10px" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder="اختر الفترة"
                    disabled={
                      gform.getFieldValue("task_id") &&
                      (() => {
                        const selectedTask = tasksTypes.find(
                          (t) => t.value === gform.getFieldValue("task_id")
                        );
                        return (
                          selectedTask &&
                          (selectedTask.label?.includes("سنوية") ||
                            selectedTask.label?.includes("سنة") ||
                            selectedTask.label?.includes("yearly") ||
                            selectedTask.label?.includes("annual"))
                        );
                      })()
                    }
                  >
                    <Option value="monthly">شهرية</Option>
                    <Option value="yearly">سنوية</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="amount"
                  label="الرصيد (دقائق)"
                  style={{ marginBottom: "10px" }}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="0"
                    min={0}
                  />
                </Form.Item>
              </div>

              <Form.Item
                name="note"
                label="ملاحظات"
                style={{ marginBottom: "15px" }}
              >
                <Input
                  style={{ width: "100%" }}
                  placeholder="ملاحظات (اختياري)"
                />
              </Form.Item>

              <Form.Item style={{ textAlign: "center", marginBottom: "10px" }}>
                <Button
                  type="primary"
                  loading={loadUsers}
                  onClick={showUsersDebt}
                  icon={<FormOutlined />}
                  size="large"
                  style={{ minWidth: "200px" }}
                >
                  جلب الموظفين
                </Button>
              </Form.Item>
            </Form>
          </div>

          {/* النموذج الديناميكي - تفاصيل الموظفين */}
          <div>
            <h3
              style={{
                marginBottom: "15px",
                color: "#52c41a",
                borderBottom: "2px solid #52c41a",
                paddingBottom: "5px",
              }}
            >
              تفاصيل الموظفين
            </h3>
            <Form form={form}>
              <Form.List name="tasks">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div
                        key={key}
                        style={{
                          background: "#fafafa",
                          padding: "15px",
                          borderRadius: "6px",
                          marginBottom: "15px",
                          border: "1px solid #d9d9d9",
                        }}
                      >
                        {/* رأس الصف */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                            paddingBottom: "8px",
                            borderBottom: "1px solid #d9d9d9",
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "#1890ff" }}
                          >
                            الموظف #{name + 1}
                          </span>
                          <Button
                            type="primary"
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => remove(name)}
                          >
                            حذف
                          </Button>
                        </div>

                        {/* الحقول الأساسية */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "15px",
                          }}
                        >
                          <Form.Item
                            name="id"
                            hidden={true}
                            style={{ display: "none" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "user_id"]}
                            label="اسم الموظف"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{
                              marginBottom: "8px",
                              gridColumn: "1 / -1",
                            }}
                          >
                            <Select
                              showSearch
                              placeholder="اختر الموظف"
                              optionFilterProp="children"
                              notFoundContent={<Spin size="small" />}
                              filterOption={(input, option) =>
                                option.props.children?.indexOf(input) >= 0 ||
                                option.props.value?.indexOf(input) >= 0 ||
                                option.props.label?.indexOf(input) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.props?.children?.localeCompare(
                                  optionB.props.children
                                )
                              }
                            >
                              {tstypes.map((item) => (
                                <Option key={item.value} value={item.value}>
                                  {item.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "task_id"]}
                            label="نوع الإجازة"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <Select
                              showSearch
                              placeholder="اختر نوع الإجازة"
                              optionFilterProp="children"
                              notFoundContent={<Spin size="small" />}
                              filterOption={(input, option) =>
                                option.props.children?.indexOf(input) >= 0 ||
                                option.props.value?.indexOf(input) >= 0 ||
                                option.props.label?.indexOf(input) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.props?.children?.localeCompare(
                                  optionB.props.children
                                )
                              }
                              onChange={(value) => {
                                const selectedTask = tasksTypes.find(
                                  (t) => t.value === value
                                );
                                if (
                                  selectedTask &&
                                  (selectedTask.label?.includes("سنوية") ||
                                    selectedTask.label?.includes("سنة") ||
                                    selectedTask.label?.includes("yearly") ||
                                    selectedTask.label?.includes("annual"))
                                ) {
                                  form.setFieldValue(
                                    [name, "period_type"],
                                    "yearly"
                                  );
                                }
                              }}
                            >
                              {tasksTypes.map((item) => (
                                <Option key={item.value} value={item.value}>
                                  {item.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "type"]}
                            label="نوع الرصيد"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <Select
                              showSearch
                              placeholder="اختر نوع الرصيد"
                              optionFilterProp="children"
                              options={
                                types && types.length > 0
                                  ? types.filter(function (e) {
                                      return e.parent == 34;
                                    })
                                  : []
                              }
                              notFoundContent={<Spin size="small" />}
                              filterOption={(input, option) =>
                                option.props.children?.indexOf(input) >= 0 ||
                                option.props.value?.indexOf(input) >= 0 ||
                                option.props.label?.indexOf(input) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.props?.children?.localeCompare(
                                  optionB.props.children
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "amount"]}
                            label="الرصيد (دقائق)"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <InputNumber
                              style={{ width: "100%" }}
                              placeholder="0"
                              min={0}
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "period_type"]}
                            label="نوع الفترة"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <Select
                              placeholder="اختر نوع الفترة"
                              disabled={
                                form.getFieldValue([name, "task_id"]) &&
                                (() => {
                                  const selectedTask = tasksTypes.find(
                                    (t) =>
                                      t.value ===
                                      form.getFieldValue([name, "task_id"])
                                  );
                                  return (
                                    selectedTask &&
                                    (selectedTask.label?.includes("سنوية") ||
                                      selectedTask.label?.includes("سنة") ||
                                      selectedTask.label?.includes("yearly") ||
                                      selectedTask.label?.includes("annual"))
                                  );
                                })()
                              }
                            >
                              <Option value="monthly">شهرية</Option>
                              <Option value="yearly">سنوية</Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "note"]}
                            label="ملاحظات"
                            style={{
                              marginBottom: "8px",
                              gridColumn: "1 / -1",
                            }}
                          >
                            <TextArea
                              placeholder="ملاحظات (اختياري)"
                              rows={2}
                              style={{ resize: "vertical" }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    ))}

                    {/* زر إضافة موظف جديد */}
                    <Form.Item
                      style={{ textAlign: "center", marginTop: "15px" }}
                    >
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                        style={{ minWidth: "200px" }}
                      >
                        إضافة موظف جديد
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        confirmLoading={dsaving}
        title="خصم رصيد إجازة"
        visible={isDModalVisible}
        onCancel={handleDCancel}
        onOk={onDFinish}
      >
        <Form form={dform}>
          <Form.Item
            name={"user_id"}
            label="اسم الموظف"
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <Select
              style={{ width: 250 }}
              showSearch
              optionFilterProp="children"
              notFoundContent={<Spin style={{ textAlign: "center" }}></Spin>}
              filterOption={(input, option) =>
                option.props.children?.indexOf(input) >= 0 ||
                option.props.value?.indexOf(input) >= 0 ||
                option.props.label?.indexOf(input) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.props?.children?.localeCompare(optionB.props.children)
              }
            >
              {tstypes.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={"task_id"}
            label="نوع الإجازة"
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <Select
              style={{ width: 100 }}
              showSearch
              optionFilterProp="children"
              notFoundContent={<Spin style={{ textAlign: "center" }}></Spin>}
              filterOption={(input, option) =>
                option.props.children?.indexOf(input) >= 0 ||
                option.props.value?.indexOf(input) >= 0 ||
                option.props.label?.indexOf(input) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.props?.children?.localeCompare(optionB.props.children)
              }
            >
              {tasksTypes.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={"amount"}
            label={"مقدار الخصم"}
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <InputNumber placeholder="الرصيد بالدقائق" />
          </Form.Item>
          <Form.Item
            name={"discount_date"}
            label={"تاريخ الخصم"}
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <DatePicker
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
            />
          </Form.Item>
          <Form.Item
            name={"note"}
            label={"ملاحظات"}
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <TextArea placeholder="ملاحظات" />
          </Form.Item>
        </Form>
      </Modal>
      <div style={{ marginBottom: "10px" }}>
        <div className="discountHeader" style={{ marginBottom: "10px" }}>
          <div className="discountBtn">
            <DatePicker
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
              value={dayjs(currentYear, "YYYY")}
              onChange={onChange}
              placeholder="اختر سنة"
              picker="year"
            />
            <Button
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                border: "none",
                backgroundColor: "#FAA61A",
                color: "#fff",
              }}
              onClick={function () {
                setIsDModalVisible(true);
              }}
            >
              <FormOutlined /> خصم رصيد{" "}
            </Button>

            <Button
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                border: "none",
                backgroundColor: "#FAA61A",
                color: "#fff",
              }}
              onClick={function () {
                setIsModalVisible(true);
              }}
            >
              <FormOutlined /> إضافة رصيد
            </Button>
            <Button
              style={{ display: "block", margin: "0 10px" }}
              onClick={function () {
                exportToExcel("xlsx");
              }}
              type="primary"
            >
              <ExportOutlined />
            </Button>

            <Button
              style={{
                display: "block",
                backgroundColor: "#0972B6",
                borderColor: "#0972B6",
              }}
              onClick={function () {
                printReport();
              }}
              type="primary"
            >
              <PrinterOutlined />
            </Button>
          </div>
        </div>
      </div>
      <Table
        loading={load}
        columns={getColumnsVac()}
        scroll={{ x: "1000px" }}
        dataSource={pdata}
        onChange={handleChange}
      />
      <div id="att-report" style={{ display: "none" }}>
        <div
          style={{
            direction: "rtl",
            fontSize: "12px",
            fontFamily: "Tajawal",
            margin: "0",
          }}
        >
          <table
            style={{ fontSize: "11px", width: " 100%", textAlign: " center" }}
          >
            <thead>
              <tr style={{ border: "none" }}>
                <th colSpan={13}>
                  <header
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderColor: "#000",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1px",
                    }}
                  >
                    <div style={{ width: "20%" }}>
                      <img
                        loading="eager"
                        style={{ width: "250px" }}
                        src={
                          Env.HOST_SERVER_STORAGE +
                          props.setting.filter(
                            (item) => item.key == "admin.logo"
                          )[0]?.value
                        }
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        paddingBottom: "10px",
                      }}
                    >
                      <h1
                        style={{
                          fontSize: " 18px",
                          fontWeight: 700,
                          marginBottom: " 5px",
                          margin: "0",
                        }}
                      >
                        كشف أرصدة الإجازات{" "}
                      </h1>
                      <h2
                        style={{
                          fontSize: " 14px",
                          fontWeight: " 200",
                          margin: "0",
                        }}
                      >
                        للفترة من {start} إلى {end}
                      </h2>
                    </div>
                    <div style={{ width: "20%" }}></div>
                  </header>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      textAlign: "center",
                      fontSize: "14px",
                      borderBottom: "1px solid black",
                    }}
                  ></div>
                </th>
              </tr>
              <tr
                style={{
                  color: "#fff",
                  backgroundColor: "#0972B6",
                  height: "25px",
                }}
              >
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  م
                </th>
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  اسم الموظف
                </th>
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  الوظيفة
                </th>

                {tasksTypes.map((item) => (
                  <th style={{ fontWeight: "100" }}>{item.label}</th>
                ))}
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  ملاحظات
                </th>
              </tr>
            </thead>
            <tbody>
              {categories.map((item) => {
                var catData = pdata?.filter(
                  (record) => record.category == item.name
                );

                var ttasksTypes = Array(tasksTypes.length).fill(0);

                if (catData.length)
                  return (
                    <>
                      {catData.map((item) => {
                        return (
                          <tr
                            style={{
                              height: " 25px",
                              backgroundColor:
                                index % 2 == 0 ? "#e6e6e6" : "#fff",
                            }}
                          >
                            <td>{index++}</td>
                            <td>{item.empName}</td>
                            <td>{item.job}</td>
                            {tasksTypes.map((task, index) => {
                              var taskAmount = item[task.label]?.replace(
                                /(\d{1,2}:\d{2}):\d{2}/,
                                "$1"
                              );
                              var taskSplit = taskAmount.split(":");

                              var finalTask =
                                taskAmount == 0
                                  ? 0
                                  : parseInt(taskSplit[0] * 60) +
                                    parseInt(taskSplit[1]);

                              ttasksTypes[index] =
                                ttasksTypes[index] + parseInt(finalTask);
                              tttasksTypes[index] =
                                tttasksTypes[index] + parseInt(finalTask);

                              return <td>{taskAmount}</td>;
                            })}
                            <td>
                              <pre> </pre>
                            </td>
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          height: " 30px",
                          color: "#fff",
                          backgroundColor: "#0972B6",
                        }}
                      >
                        <td colSpan={3}>{item.name}</td>
                        {tasksTypes.map((task, index) => {
                          return (
                            <td>
                              {parseInt(ttasksTypes[index] / 60) +
                                ":" +
                                (ttasksTypes[index] % 60)}
                            </td>
                          );
                        })}
                        <td>
                          <pre> </pre>
                        </td>
                      </tr>
                    </>
                  );
              })}
              <tr
                style={{
                  height: " 30px",
                  color: "#fff",
                  backgroundColor: "#0972B6",
                }}
              >
                <td colSpan={3}>{"الإجمالي العام"}</td>
                {tasksTypes.map((task, index) => {
                  return (
                    <td>
                      {parseInt(tttasksTypes[index] / 60) +
                        ":" +
                        (tttasksTypes[index] % 60)}
                    </td>
                  );
                })}
                <td>
                  <pre> </pre>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={16}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "20px",
                      textAlign: "center",
                    }}
                  >
                    {props.setting
                      .filter((item) => item.key == "admin.signs_footer")[0]
                      ?.value.split("\n")
                      .map((sign) => {
                        var sign_position = sign.split(":")[0];
                        var sign_name = sign.split(":")[1];

                        return (
                          <div style={{ width: "50%" }}>
                            <div style={{ fontWeight: "900" }}>
                              {sign_position}
                            </div>
                            {sign_name != "" && (
                              <div style={{ fontWeight: "500" }}>
                                {sign_name}
                              </div>
                            )}
                          </div>
                        );
                      })}{" "}
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
          <div
            style={{
              marginTop: " 20px",
              width: "85%",
              backgroundColor: "#e6e6e61",
              padding: "5px 0",
              borderTopLeftRadius: " 5px",
              borderBottomLeftRadius: " 5px",
            }}
          >
            <div
              style={{
                backgroundColor: " #0972B6",
                width: " 95%",
                height: " 15px",
                borderTopLeftRadius: " 5px",
                borderBottomLeftRadius: " 5px",
                color: " #fff",
                paddingRight: " 20px",
              }}
            >
              نظام دوام | {new Date().toLocaleString("en-IT")}{" "}
            </div>
          </div>
        </div>
      </div>
      <div id="ann-report" style={{ display: "none" }}>
        <div
          style={{
            direction: "rtl",
            fontSize: "12px",
            fontFamily: "Tajawal",
            margin: "0",
          }}
        >
          <table
            class="equal-table"
            style={{ fontSize: "11px", width: " 100%", textAlign: " center" }}
          >
            <thead>
              <tr style={{ border: "none" }}>
                <th colSpan={21}>
                  <header
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderColor: "#000",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1px",
                    }}
                  >
                    <div style={{ width: "20%" }}>
                      <img
                        loading="eager"
                        style={{ width: "250px" }}
                        src={
                          Env.HOST_SERVER_STORAGE +
                          props.setting.filter(
                            (item) => item.key == "admin.logo"
                          )[0]?.value
                        }
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        paddingBottom: "10px",
                      }}
                    >
                      <h1
                        style={{
                          fontSize: " 18px",
                          fontWeight: 700,
                          marginBottom: " 5px",
                          margin: "0",
                        }}
                      >
                        كشف السنوية لعام {currentYear}م
                      </h1>
                    </div>
                    <div style={{ width: "20%" }}></div>
                  </header>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      textAlign: "center",
                      fontSize: "14px",
                      borderBottom: "1px solid black",
                    }}
                  ></div>
                </th>
              </tr>

              <tr style={{ color: "#fff", backgroundColor: "#0972B6" }}>
                <th style={{ fontWeight: "100" }}>م</th>
                <th style={{ fontWeight: "100" }}>اسم الموظف</th>
                <th style={{ fontWeight: "100" }}>الوظيفة</th>
                <th style={{ fontWeight: "100", width: "50px" }}>
                  مرحل من العام الماضي
                </th>
                <th style={{ fontWeight: "100", width: "50px" }}>
                  رصيد العام الحالي
                </th>
                <th style={{ fontWeight: "100", width: "50px" }}>رصيد محول</th>
                <th style={{ fontWeight: "100" }}>الافتتاحي</th>

                {months.map((m, ind) => {
                  return (
                    <th
                      class="equal"
                      style={{
                        fontWeight: "100",
                        whiteSpace: "nowrap",
                        transform: "rotate(-180deg)",
                        writingMode: "vertical-rl",
                        height: "30px",
                        width: "30px",
                        maxWidth: "30px",
                      }}
                    >
                      {months[ind]}
                    </th>
                  );
                })}
                <th style={{ fontWeight: "100" }}> الممنوح</th>
                <th style={{ fontWeight: "100" }}> المتبقي</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((item) => {
                var catData = pannTasks.filter(
                  (record) => record.category == item.name
                );
                var prevBalance = 0;
                var currBalance = 0;
                var transBalance = 0;
                var opBalance = 0;
                var totalgBalance = 0;
                var monthsBalance = {
                  m1: 0,
                  m2: 0,
                  m3: 0,
                  m4: 0,
                  m5: 0,
                  m6: 0,
                  m7: 0,
                  m8: 0,
                  m9: 0,
                  m10: 0,
                  m11: 0,
                  m12: 0,
                };
                if (catData.length)
                  return (
                    <>
                      {catData.map((item) => {
                        prevBalance += item.prev * 1;
                        currBalance += item.curr * 1;
                        transBalance += item.trans * 1;
                        var totalg = 0;
                        var op =
                          Math.round(item.prev) +
                          Math.round(item.curr) +
                          Math.round(item.trans);
                        opBalance += op;

                        tprevBalance += item.prev * 1;
                        tcurrBalance += item.curr * 1;
                        ttransBalance += item.trans * 1;
                        topBalance += op;

                        return (
                          <tr
                            style={{
                              height: " 25px",
                              backgroundColor:
                                aindex % 2 == 0 ? "#e6e6e6" : "#fff",
                            }}
                          >
                            <td style={{ fontWeight: "100" }}>{aindex++}</td>
                            <td style={{ fontWeight: "100" }}>{item.name}</td>
                            <td style={{ fontWeight: "100", width: "100px" }}>
                              {item.job}
                            </td>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.prev / 60) +
                                ":" +
                                Math.round(item.prev % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.curr / 60) +
                                ":" +
                                Math.round(item.curr % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.trans / 60) +
                                ":" +
                                Math.round(item.trans % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(op / 60) + ":" + (op % 60)}
                            </th>
                            {months.map((m, ind) => {
                              var min = item["m" + (ind + 1)] / 60;
                              totalg += min;
                              totalgBalance += min;
                              monthsBalance["m" + (ind + 1)] += min;
                              ttotalgBalance += min;
                              tmonthsBalance["m" + (ind + 1)] += min;
                              return (
                                <td class="equal" style={{ fontWeight: "100" }}>
                                  {parseInt(min / 60) + ":" + (min % 60)}
                                </td>
                              );
                            })}
                            <td style={{ fontWeight: "100" }}>
                              {Math.round((totalg / 60 / 7) * 100) / 100}
                            </td>
                            <th style={{ fontWeight: "100" }}>
                              {Math.round(((op - totalg) / 60 / 7) * 100) / 100}
                            </th>
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          height: " 25px",
                          color: "#fff",
                          backgroundColor: "#0972B6",
                        }}
                      >
                        <td style={{ fontWeight: "100" }} colSpan={3}>
                          {item.name}
                        </td>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(prevBalance / 60) +
                            ":" +
                            Math.round(prevBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(currBalance / 60) +
                            ":" +
                            Math.round(currBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(transBalance / 60) +
                            ":" +
                            Math.round(transBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(opBalance / 60) + ":" + (opBalance % 60)}
                        </th>
                        {months.map((m, ind) => {
                          var min = monthsBalance["m" + (ind + 1)];
                          return (
                            <td class="equal" style={{ fontWeight: "100" }}>
                              {parseInt(min / 60) + ":" + (min % 60)}
                            </td>
                          );
                        })}
                        <td style={{ fontWeight: "100" }}>
                          {Math.round((totalgBalance / 60 / 7) * 100) / 100}
                        </td>
                        <th style={{ fontWeight: "100" }}>
                          {Math.round(
                            ((opBalance - totalgBalance) / 60 / 7) * 100
                          ) / 100}
                        </th>
                      </tr>
                    </>
                  );
              })}
              <tr
                style={{
                  height: " 30px",
                  color: "#fff",
                  backgroundColor: "#0972B6",
                }}
              >
                <td colSpan={3}>{"الإجمالي العام"}</td>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(tprevBalance / 60) +
                    ":" +
                    Math.round(tprevBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(tcurrBalance / 60) +
                    ":" +
                    Math.round(tcurrBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(ttransBalance / 60) +
                    ":" +
                    Math.round(ttransBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(topBalance / 60) + ":" + (topBalance % 60)}
                </th>
                {months.map((m, ind) => {
                  var min = tmonthsBalance["m" + (ind + 1)];
                  return (
                    <td class="equal" style={{ fontWeight: "100" }}>
                      {parseInt(min / 60) + ":" + (min % 60)}
                    </td>
                  );
                })}
                <td style={{ fontWeight: "100" }}>
                  {Math.round((ttotalgBalance / 60 / 7) * 100) / 100}
                </td>
                <th style={{ fontWeight: "100" }}>
                  {Math.round(((topBalance - ttotalgBalance) / 60 / 7) * 100) /
                    100}
                </th>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={21}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "20px",
                      textAlign: "center",
                    }}
                  >
                    {props.setting
                      .filter((item) => item.key == "admin.signs_footer")[0]
                      ?.value.split("\n")
                      .map((sign) => {
                        var sign_position = sign.split(":")[0];
                        var sign_name = sign.split(":")[1];

                        return (
                          <div style={{ width: "50%" }}>
                            <div style={{ fontWeight: "900" }}>
                              {sign_position}
                            </div>
                            {sign_name != "" && (
                              <div style={{ fontWeight: "500" }}>
                                {sign_name}
                              </div>
                            )}
                          </div>
                        );
                      })}{" "}
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
          <div
            style={{
              marginTop: " 20px",
              width: "85%",
              backgroundColor: "#e6e6e61",
              padding: "5px 0",
              borderTopLeftRadius: " 5px",
              borderBottomLeftRadius: " 5px",
            }}
          >
            <div
              style={{
                backgroundColor: " #0972B6",
                width: " 95%",
                height: " 15px",
                borderTopLeftRadius: " 5px",
                borderBottomLeftRadius: " 5px",
                color: " #fff",
                paddingRight: " 20px",
              }}
            >
              نظام دوام | {new Date().toLocaleString("en-IT")}{" "}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
